"use strict";
import r from "./index.es144.js";
import g from "./index.es158.js";
const l = (s) => s instanceof g ? { ...s } : s;
function b(s, a) {
  a = a || {};
  const c = {};
  function o(i, n, t, f) {
    return r.isPlainObject(i) && r.isPlainObject(n) ? r.merge.call({ caseless: f }, i, n) : r.isPlainObject(n) ? r.merge({}, n) : r.isArray(n) ? n.slice() : n;
  }
  function u(i, n, t, f) {
    if (r.isUndefined(n)) {
      if (!r.isUndefined(i))
        return o(void 0, i, t, f);
    } else return o(i, n, t, f);
  }
  function d(i, n) {
    if (!r.isUndefined(n))
      return o(void 0, n);
  }
  function e(i, n) {
    if (r.isUndefined(n)) {
      if (!r.isUndefined(i))
        return o(void 0, i);
    } else return o(void 0, n);
  }
  function m(i, n, t) {
    if (t in a)
      return o(i, n);
    if (t in s)
      return o(void 0, i);
  }
  const p = {
    url: d,
    method: d,
    data: d,
    baseURL: e,
    transformRequest: e,
    transformResponse: e,
    paramsSerializer: e,
    timeout: e,
    timeoutMessage: e,
    withCredentials: e,
    withXSRFToken: e,
    adapter: e,
    responseType: e,
    xsrfCookieName: e,
    xsrfHeaderName: e,
    onUploadProgress: e,
    onDownloadProgress: e,
    decompress: e,
    maxContentLength: e,
    maxBodyLength: e,
    beforeRedirect: e,
    transport: e,
    httpAgent: e,
    httpsAgent: e,
    cancelToken: e,
    socketPath: e,
    responseEncoding: e,
    validateStatus: m,
    headers: (i, n, t) => u(l(i), l(n), t, !0)
  };
  return r.forEach(Object.keys({ ...s, ...a }), function(i) {
    const n = p[i] || u, t = n(s[i], a[i], i);
    r.isUndefined(t) && n !== m || (c[i] = t);
  }), c;
}
export {
  b as default
};
//# sourceMappingURL=index.es147.js.map
